import { modals } from '@mantine/modals'
import showModalNotificationError from '@v2/commons/modals/ModalNotification/showModalNotificationError'
import { useRouter } from '@v2/commons/utils/navigation'
import { DEFAULT_ROUTES } from '@v2/domains/routing/types/routing.types'
import { getRoutePath } from '@v2/domains/routing/utils/route.utils'
import { useEffect } from 'react'

import { useGetClinicQuery } from '../api/clinic.api'

export const useClinic = (clinicId: string) => {
  const { data, isLoading, isSuccess, isError, refetch } =
    useGetClinicQuery(clinicId)

  const router = useRouter()

  useEffect(() => {
    if (isError) {
      showModalNotificationError({
        subtitle: 'Error fetching clinic information',
        buttonText: 'Retry',
        onClickBtn: () => refetch(),
        onCancel: () => router.push(getRoutePath(DEFAULT_ROUTES.LOCATIONS)),
      })
    } else {
      modals.closeAll()
    }
  }, [isError])

  return {
    clinic: data,
    isLoading,
    isSuccess,
    isError,
  }
}
